import HeaderMenu from '@ui/Header/Menu/BS/component'
import trustPilot from '@ui/ThirdParty/Trustpilot/component'
import collapsibleBlock from 'assets/core/js/module/collapsibleBlock'
import readMoreText from 'assets/core/js/module/readMoreText'
import stickyObserver from 'assets/core/js/module/stickyObserver'
import tooltip from 'assets/themes/campings/js/module/tooltip'
import help from 'assets/themes/campings/js/page/common/help'
import common from 'assets/themes/campings/js/page/common/index'

common.preInit()

document.addEventListener('DOMContentLoaded', function () {
  common.init()

  // temporary: disable legacy BS service worker
  if ('serviceWorker' in navigator && document.body.getAttribute('data-application-id')?.match(/site-bungalow-specials/)) {
    navigator.serviceWorker
      .getRegistrations()
      .then(async (registrations) => {
        for (const registration of registrations) {
          await registration.unregister()
        }
      })
      .catch(() => {})
  }

  HeaderMenu()

  collapsibleBlock()
  readMoreText()

  help()
  stickyObserver()
  trustPilot()

  tooltip()
})
